export function isMemberImportSimulationResponse(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const item = value;
    return (typeof item.sourceSheet === 'string' &&
        typeof item.generatedAt === 'string' &&
        item.sourceRowsPreserved === true &&
        item.writesPerformed === false &&
        ['total', 'creates', 'updates', 'omissions', 'preservedForReview'].every((key) => Number.isInteger(item[key])) &&
        Array.isArray(item.rows) &&
        item.rows.every((row) => {
            if (typeof row !== 'object' || row === null)
                return false;
            const candidate = row;
            return (typeof candidate.id === 'string' &&
                Number.isInteger(candidate.rowNumber) &&
                (candidate.slotNumber === null || typeof candidate.slotNumber === 'string') &&
                (candidate.fullName === null || typeof candidate.fullName === 'string') &&
                (candidate.nationalId === null || typeof candidate.nationalId === 'string') &&
                ['create', 'update', 'omit'].includes(candidate.action ?? '') &&
                typeof candidate.reason === 'string' &&
                (candidate.existingMemberId === null || typeof candidate.existingMemberId === 'string'));
        }));
}
